import "./DelayList.scss";
import { ReactSVG } from "react-svg";
import { DCTable, SortItems, SortRequestModel } from "../Wrappers/DCTable";
import { ChangeEvent, useEffect, useState, useContext, useRef } from "react";
import { DelayListModel } from "../../Model/DelayListModel";
import { GetDelayCode,DeleteMaintdelay } from "../../services/DelayListService/DelayListService";
import { DelayCollectionModel } from "../../Model/DelayListCollection";
import { AuthContext } from "../../providers/AuthProvider";
import { DCDatePicker } from "../Wrappers/DCDatePicker";
import { AddEntry } from "../AddEntry/AddEntry";
import LoadingSpinner from "../Spinner/spinner";
import { DCInput } from "../Wrappers/DCInput";
import { useDispatch, useSelector } from 'react-redux';
import App from "../../App";
import { fetchDelayCodes } from "../../state/actions/DelayCodeAction";
import { fetchAllValidAircrafts } from "../../state/actions/AircraftAction";
import { fetchFltopsDelays } from "../../state/actions/FltopsDelaysAction";
import { deleteMaintDelay, fetchMaintDelays } from "../../state/actions/MaintDelaysAction";
import { DelayListRecordWithAction } from "../../Model/DelayListRecordWithAction";
import { 
  selectMaintListLoading, 
  selectFltopsListLoading, 
  selectMaintListError, 
  selectFltopsListError,
  selectMaintList,
  selectFltopsList 
} from '../../state/selectors/DelayListSelectors';

import { getSecureRandom } from '../../utils/utils';
import { 
  handleSaveFlightDelayDetail as handleSaveFlightDelayDetailHelper,
  DelayListDependencies,
  transformMaintListToDelayList,
  transformFltopsListToDelayList,
  buildCompositeFlightId
} from '../../utils/delayListHelpers';

interface DelayListInterface {
  handleAlert: (page: string, type: string, msg: string, id: number) => any;
}

export default function DelayList({ handleAlert }: DelayListInterface) {
  const {
    getAccessToken,
    getAdminStatus,
    getMaintainerStatus,
  } = useContext(AuthContext);
  const dispatch = useDispatch();

  const [delayList, setDelayList] = useState<DelayListModel[]>([]);
  const [intialDelayList, setInitialDelayList] = useState<DelayListModel[]>([]);
  const [filterValue, setFilterValue] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [isChecked, setIsChecked] = useState(true);
  const [ACNumber, setACNumber] = useState("");
  const [Flt, setFlt] = useState(0);
  const [Stn, setStn] = useState("");
  const [DelayCode, setDelayCode] = useState("");
  const [DepFlightNbr, setDepFlightNbr] = useState("");
  const [Source, setSource] = useState("");
  const [addEntryKey, setAddEntryKey] = useState(0);
  const [isFilterIconClicked, setIsFilterIconClicked] = useState(false);
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [isApiResponseReceived, setIsApiResponseReceived] = useState(true);
  const[maintDncId,setMaintDncId]=useState("");
  const [openDeleteDialog, setDeleteDialogOpen] = useState(false); 
  const [openDialog, setDialogOpen] = useState(false); 
  const [numRules, setNumRules] = useState<number>(0);
  const [ACReg, setACReg] = useState("");
  const [Station, setStation] = useState("");
  const [Flight, setFlight] = useState("");
  const [isDisable, setDisable] = useState(false);
  const [openDelayEntryDialog, setOpenDelayEntryDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);
  // Row order the user is currently looking at; only a column-header click reorders it.
  const displayOrderRef = useRef<string[]>([]);
  const columnWidthSmaller=4;
  const columnWidthWider=32;
 
  // Fetch the delay codes from the API and update the redux store
  useEffect(() => {
    const intervalMS = Number(process.env.REACT_APP_DELAY_CODES_CACHE_INTERVAL_MS) || 60000;
    console.log("Delay Codes Cache Interval: ", intervalMS);    
    // Dispatch the fetchDelayCodes action to fetch the delay codes
    const fetchCodes = () => {
      // Get the access token from the AuthContext
      const token = getAccessToken();
      dispatch(fetchDelayCodes(token) as any);
    };
    
    const fetchAircrafts = () => {
      // Get the access token from the AuthContext
      const token = getAccessToken();
      dispatch(fetchAllValidAircrafts(token) as any);
    }
    // Fetch the delay codes initially and then every 60 seconds    
    fetchCodes();
    // Fetch the aircrafts initially and then every 60 seconds
    fetchAircrafts();
    const intervalId = setInterval(fetchCodes, intervalMS);
    const intervalId2 = setInterval(fetchAircrafts, intervalMS);
    return () => {
      clearInterval(intervalId);
      clearInterval(intervalId2);
    };
  
  }, [dispatch, getAccessToken]);

  useEffect(() => {
    const currentDate = getCurrentDate();
      setSearchDate(currentDate);
      fetchData();
      //handleToggleChange();
  }, []);

  //Subscribe to the delayCodes state  
  const { delayCodes, loading, error } = useSelector((state: any) => state.delayCodesState);
  const { aircraftList,aircraftListLoading, aircraftListError } = useSelector((state: any) => state.aircraftState);
  // If error occurs while fetching delay codes, show an alert
  useEffect(() => {
    //Only if delayCodes is empty and error
    if (!loading && delayCodes.length === 0 && error) {
      handleAlert("Delay Codes", "error", error, getSecureRandom());
    }
  }, [error]);

  // If error occurs while fetching aircrafts, show an alert
  useEffect(() => {
    //Only if delayCodes is empty and error
    console.log(aircraftList)
    if (!aircraftListLoading && aircraftList.length === 0 && aircraftListError) {
      handleAlert("Aircrafts", "error", aircraftListError, getSecureRandom());
    }
  }, [aircraftListError]);

  
  useEffect(() => {
    if (!searchDate.length || !validateDateYear()) {
      setDisable(true)
    } else {
      setDisable(false)
    }
  }, [searchDate]);

  const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based
    const day = now.getDate().toString().padStart(2, "0");
    const currentDate = `${year}-${month}-${day}`;
    return currentDate;
  }

  const getRowKey = (record: DelayListModel): string =>
    buildCompositeFlightId(record.flightSegmentId, record.dptFlightNo);

  /** Reorder the list to match the order the user last saw, appending records it has never seen. */
  const applySavedDisplayOrder = (list: DelayListModel[]): DelayListModel[] => {
    const rank = new Map(displayOrderRef.current.map((key, index) => [key, index]));
    const known: DelayListModel[] = [];
    const unseen: DelayListModel[] = [];

    list.forEach((record) => {
      (rank.has(getRowKey(record)) ? known : unseen).push(record);
    });

    known.sort((a, b) => rank.get(getRowKey(a))! - rank.get(getRowKey(b))!);
    return [...known, ...unseen];
  };

  /** Keys of rows hidden by a filter are kept so they return to their old spot when the filter clears. */
  const rememberDisplayOrder = (list: DelayListModel[]): void => {
    const knownKeys = new Set(displayOrderRef.current);
    const newKeys = list.map(getRowKey).filter((key) => !knownKeys.has(key));
    displayOrderRef.current = [...displayOrderRef.current, ...newKeys];
  };

  const onDelayEntryDialogClose = () => {
    setAddEntryKey((prevKey) => prevKey + 1);
    //fetchData();
  };
  //call applyfilters when filterValue or isChecked changes
  useEffect(() => {
    applyFilters();
  }, [isChecked, intialDelayList,filterValue]);

  useEffect(() => {
      setIsChecked(true);
  }, [searchDate]);

  /** User clicks on the column to be sorted - the only place the list is reordered */
  const handleSortChange = (event: SortRequestModel) => {
    // Create a new sorted array instead of mutating the original
    const sortedTable = [...delayList].sort((a: any, b: any) =>
      SortItems(a, b, event)
    );

    displayOrderRef.current = sortedTable.map(getRowKey);
    setDelayList(sortedTable);
  };

  //filter table values based on user input
  const matchesSearchFilter = (delay: DelayListModel): boolean => {
    const searchLower = filterValue.toLowerCase();
    return (
      delay.ac.toLowerCase().includes(searchLower) ||
      delay.stn.toLowerCase().includes(searchLower) ||
      delay.dptFlightNo.toLowerCase().includes(searchLower) ||
      delay.delayTimeLen.toString().includes(searchLower) ||
      delay.scheddepart.toLowerCase().includes(searchLower) ||
      delay.source.toLowerCase().includes(searchLower) ||
      delay.dcCode.toLowerCase().includes(searchLower) ||
      delay.discrepancyRemark.toString().toLowerCase().includes(searchLower) ||
      delay.comments.toString().toLowerCase().includes(searchLower)
    );
  };

  const matchesToggleFilter = (delay: DelayListModel): boolean => {
    const source = delay.source.toLowerCase();
    const dcCode = delay.dcCode.toLowerCase();
    return (
      (source === "fltopsd" && (dcCode === "m" || dcCode === "d")) ||
      source === "m&e" ||
      (source === "fltopsc" && (dcCode.includes("mech") || dcCode.includes("maint") || dcCode.includes("mx") || dcCode.includes("mtx")))
    );
  };

  const applySearchFilter = (list: DelayListModel[]): DelayListModel[] => {
    if (filterValue.length === 0) return list;
    setIsFilterOn(true);
    return list.filter(matchesSearchFilter);
  };

  const applyToggleFilter = (list: DelayListModel[]): DelayListModel[] => {
    if (!isChecked) return list;
    return list.filter(matchesToggleFilter);
  };

  const applyFilters = () => {
    setIsFilterOn(false);
    let filteredList = [...intialDelayList];
    
    filteredList = applySearchFilter(filteredList);
    filteredList = applyToggleFilter(filteredList);

    const orderedList = applySavedDisplayOrder(filteredList);
    rememberDisplayOrder(orderedList);
    setDelayList(orderedList);
  };

  const errorRuleEventHandler=(data:string,page:string)=>{

    setDialogOpen(false);
    setDeleteDialogOpen(false);
    handleAlert(page, "error", data, getSecureRandom())
  
  }
  
  const deleteRuleEventHandler = (data: string,page:string) => {
    console.info("Delyalist m&E deleted: " + data);
    setNumRules(numRules - 1);
   
    setDeleteDialogOpen(false);
    handleAlert(page, "success", data, getSecureRandom())
  };
  const cancelRuleEventHandler = () => {
    console.info("New Delaylist capture cancelled");
    setDeleteDialogOpen(false);
    setDialogOpen(false);
  };

  const onDeleteEntry=(maintDncId:string,aircraft:string,station:string,deptFlight:string)=>{
    setMaintDncId(maintDncId);
   setStation(station);
   setACReg(aircraft);
   setFlight(deptFlight); 
    deletemaintdelay(maintDncId,"Delay Details",aircraft,station,deptFlight);
  }
  /**A record has been deleted*/
 
const deletemaintdelay = async ( maintDncId: string,page:string,aircraft:string,station:string,deptFlight:string) => {
    DeleteMaintdelay( getAccessToken(),maintDncId)
        .then((response) => {
            if (response)
            {
              deleteRuleEventHandler(` Successfully deleted record with A/C:  ${aircraft} , STN: ${station}  , Flt Nbr: ${deptFlight} `,page);
              //fetchData();
              // Dispatch action to remove the record from Redux
                dispatch(deleteMaintDelay(maintDncId));

            }
            else
            {
              errorRuleEventHandler(` Failed deleting record with A/C:  ${aircraft} , STN: ${station}  , Flt Nbr: ${deptFlight} `,page);
            }
            setDeleteDialogOpen(false);

        })
        .catch((error) => {
          errorRuleEventHandler(` Failed deleting record with A/C:  ${aircraft} , STN: ${station}  , Flt Nbr: ${deptFlight} `+ "Message: "+ error.message,page);
          setDeleteDialogOpen(false);
    });
  }
/**User clicks on delete button*/

const callConfirmDeletePopup=(maintDncId:string,aircraft:string,station:string,deptFlight:string)=>{
   setMaintDncId(maintDncId);
   setStation(station);
   setACReg(aircraft);
   setFlight(deptFlight); 
  setDeleteDialogOpen(true);
};


  const handleFilterIconClick = () => {
    setIsFilterIconClicked(!isFilterIconClicked);
  };

  const handleFilterCloseIcon = () => {
    setFilterValue("");
    //setIsChecked(false);
    setIsFilterIconClicked(false);
  };

  // Event handler for filterInput
  const handleFilterInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    setFilterValue(inputValue);
  
  };

  // Event handler for toggle switch
    const handleToggleChange = (event?: ChangeEvent<HTMLInputElement>) => {
        const  checked  = event ? event.target.checked : isChecked;
        setIsChecked(checked);
        applyFilters();

  };
  const handleEnterKeypressOnSearchButton=(event: React.KeyboardEvent<HTMLInputElement>) =>{
    if (event.key == 'Enter' && searchDate!=="" && validateDateYear()) {
      fetchData();
    }
  }

  function validateDateYear() {
    let isYearValid = true;
    let date = new Date(searchDate);
    if (date.getFullYear().toString().length > 4) {
      isYearValid = false;
    }
    return isYearValid
  }

  // Add these selectors for delays from Redux

var date = searchDate || getCurrentDate();
var token = getAccessToken();

async function fetchData() {
  setIsApiResponseReceived(false);
  setIsChecked(true);
  setFilterValue("");
  setSelectedRowId("")
  setDelayList([]);
  displayOrderRef.current = [];
  setInitialDelayList([]);
  date = searchDate || getCurrentDate();
  token = getAccessToken();
  dispatch(fetchMaintDelays(token, Stn, DelayCode, date) as any);
  dispatch(fetchFltopsDelays(token, Stn, DelayCode, date) as any);
}


const fltopslist: DelayCollectionModel[] = useSelector(selectFltopsList);
const fltopslistLoading: boolean = useSelector(selectFltopsListLoading);
const fltopslistError: string | null = useSelector(selectFltopsListError);

const maintlist: DelayCollectionModel[] = useSelector(selectMaintList);
const maintlistLoading: boolean = useSelector(selectMaintListLoading);
const maintlistError: string | null = useSelector(selectMaintListError);

 useEffect(() => {
    
    console.log(fltopslist)
    if (!fltopslistLoading && fltopslist.length === 0 && fltopslistError) {
      handleAlert("Error fetching Fltops list", "error", fltopslistError, getSecureRandom());
    }
  }, [fltopslistError]);

  useEffect(() => {
    if (!maintlistLoading && maintlist.length === 0 && maintlistError) {
      handleAlert("Error fetching M&E list", "error", maintlistError, getSecureRandom());
    }
  }, [maintlistError]);
  
 
//Use useEffect to process when both lists are loaded:
useEffect(() => {
    const processFetchDataAsync = async () => {
      if (!maintlistLoading && !fltopslistLoading) {
        try {
          // The list is deliberately left rendered while the refreshed data is built;
          // emptying it first collapses the scroll container and loses the scroll position.
          let initialDelayList: DelayListModel[] = [];
          console.log(fltopslist);
          let fltSegIds: { [key: string]: number } = {};
          let h = new Map();

          if (fltopslist.length > 0) {
            fltopslist.forEach((fltdl) => {
              if (fltdl.FlightSegmentId === 0) {
                return;
              }
              setACNumber(fltdl.DelayStation);
              setDepFlightNbr(fltdl.FlightNumber.padStart(4, "0"));
              fltSegIds[fltdl.FlightSegmentId.toString().trim() + fltdl.FlightNumber.padStart(4, "0")] =
                fltdl.FlightSegmentId;
            });
          }
          if (maintlist.length > 0 || fltopslist.length > 0) {
            if (maintlist.length > 0) {
              initialDelayList = await transformMaintListToDelayList(
                maintlist,
                token,
                Stn,
                DepFlightNbr,
                date,
                h
              );             
            }
            if (fltopslist.length > 0) {
              const finitialDelayList = await transformFltopsListToDelayList(
                fltopslist,
                h,
                Flt,
                Source
              );
              initialDelayList = [...initialDelayList, ...finitialDelayList];
            }
            setInitialDelayList(initialDelayList);
          } else {
            setInitialDelayList([]);
          }

        } catch (error) {
          handleAlert("Delay List", "error", "" + error, getSecureRandom());
          console.log(error);
        }
        finally {
          setIsApiResponseReceived(true);
        }
      };

      
    }
    processFetchDataAsync();
}, [fltopslist, maintlist,fltopslistLoading,maintlistLoading]);

  const handleSaveFlightDelayDetail = async (savedRecord: DelayListRecordWithAction) => {
    // Create dependencies object for the extracted helper
    const deps: DelayListDependencies = {
      dispatch,
      setSelectedRowId,
      handleAlert,
      maintlist,
      getSecureRandom
    };

    // Call the extracted helper function
    handleSaveFlightDelayDetailHelper(savedRecord, deps);
  };

 
  return (
    <div className="ComponentContent">
      <div className="ComponentHeader">
        <div className="ComponentHeaderTitle">
        </div>
        <div className="ComponentDatepicker">
          <DCDatePicker
            value={searchDate}
            placeholder={"Date"}
            required={true}
            onBlur={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSearchDate(e.currentTarget.value)
            }
            onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSearchDate(e.currentTarget.value)
            }
            onKeyUp={handleEnterKeypressOnSearchButton}
          />
        </div>
        <div className="ComponentStationInput">
          <DCInput
            value={Stn}
            maxLength={50} // Set maxLength as per your requirement
            placeholder="Station (optional)"
            required={false} // Set required as per your requirement
            disable={false} // Set disable as per your requirement
            onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setStn(e.currentTarget.value)
            }
            onKeyUp={handleEnterKeypressOnSearchButton}
          />
        </div>
        <div className="ComponentDelayCodeInput">
          <DCInput
            value={DelayCode}
            maxLength={50} // Set maxLength as per your requirement
            placeholder="Delay Code (optional)"
            required={false} // Set required as per your requirement
            disable={false} // Set disable as per your requirement
            onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setDelayCode(e.currentTarget.value)
            }
            onKeyUp={handleEnterKeypressOnSearchButton}
          />
        </div>
        <div className="ComponentSearchButton">
          <auro-button slim secondary onClick={() => fetchData()} disabled={isDisable ? "disabled": undefined}>
            <auro-icon customColor category="interface" name="search" slot="icon"></auro-icon>
            Search
          </auro-button>
        </div>
        <div className="ComponentFilterIcon">
          <auro-icon
          data-testid="filterIcon"
            id={isFilterOn ? "filterOn" : (isFilterIconClicked ? "filterIconClicked" : "filterIconNotClicked")}
            category="interface"
            name="filter"
            customColor
            onClick={handleFilterIconClick}
          />
        </div>
        <div className="ComponentDelayListActionsToggle">
            <span className="toggleCaption">Maint/Damage Only</span>
            <label className="switch">
              <input
              data-testid="toggleSwitch"
                type="checkbox"
                aria-label="Toggle Maint/Damage Only"
                onChange={handleToggleChange}
                checked={isChecked}
              />
              <span className="slider round"></span>
            </label>
          </div>
      </div>
      {isFilterIconClicked && (
        <div className=" ComponentDelayListActions">
          <div className="ComponentDelayListActionsFilter">
            <DCInput
              value={filterValue}
              maxLength={50} // Set maxLength as per your requirement
              placeholder="Filter By Keyword (optional)"
              required={false} // Set required as per your requirement
              disable={false} // Set disable as per your requirement
              onInputChange={handleFilterInputChange}
            />
          </div>
         
          <div className="ComponentDelayListActionsClose">
            <ReactSVG
              src="https://cdn.jsdelivr.net/npm/@alaskaairux/icons@latest/dist/icons/interface/x-lg.svg"
              onClick={() => handleFilterCloseIcon()}
            />
          </div>
        </div>
      )}
      <div className="ComponentDelayListTable">
      {!isApiResponseReceived ? 
      <LoadingSpinner />  :
      //<auro-loader className="loader" ringworm md></auro-loader> :
        <DCTable
          columnsDefinition={[
            {
              key: "ac",
              name: "A/C",
              sortable: true,
              dataFormat: "string",
              clickable: true,
              width: columnWidthSmaller,
            },
            {
              key: "stn",
              name: "STN",
              sortable: true,
              dataFormat: "string",
              clickable: false,
              width: columnWidthSmaller,
            },
            {
              key: "dptFlightNo",
              name: "Flight Nbr",
              sortable: true,
              dataFormat: "string",
              clickable: false,
              width: columnWidthSmaller,
            },
            {
              key: "delayTimeLen",
              name: "Delay Time",
              sortable: true,
              dataFormat: "string",
              clickable: false,
              width: columnWidthSmaller,
            },
            {
              key: "scheddepart",
              name: "Sched Depart",
              sortable: true,
              dataFormat: "string",
              clickable: false,
              width: columnWidthSmaller,
            },
            {
              key: "source",
              name: "Source",
              sortable: true,
              dataFormat: "string",
              clickable: false,
              width: columnWidthSmaller,
            },
            {
              key: "dcCode",
              name: "DC Code",
              sortable: true,
              dataFormat: "string",
              clickable: false,
              width: columnWidthSmaller,
            },
            {
              key: "discrepancyRemark",
              name: "Discrepancy Remark",
              sortable: true,
              dataFormat: "string",
              clickable: false,
              width: columnWidthWider,
              limitline: true,
            },
            {
              key: "comments",
              name: "Comments",
              sortable: true,
              dataFormat: "string",
              clickable: false,
              width: columnWidthWider,
              limitline: true,
            },
          ]}
          tableData={delayList}
          keyFieldName="maintDncId"
          onSortChange={(event: SortRequestModel) => handleSortChange(event)}
          searchDate={searchDate}
          onDeleteClick={(id: string,aircraft:string,station:string,deptFlight:string) => callConfirmDeletePopup(id,aircraft,station,deptFlight)}
          onDelayEntryDialogClose={() => onDelayEntryDialogClose()}
          onDeleteEntry={(id: string, aircraft: string, station: string, deptFlight: string) => onDeleteEntry(id, aircraft, station, deptFlight)}
          onError={(data: string) => errorRuleEventHandler(data,"Delay Details")}
          closeDialog={() => setOpenDelayEntryDialog(false)}
          selectedRowId={selectedRowId} // Pass the selected row ID
          onRowSelect={setSelectedRowId} // Pass the callback to update the selected row ID
          onSaveFlightDelayDetail={handleSaveFlightDelayDetail}
        />
       }
      </div>
      {(getAdminStatus().value || getMaintainerStatus().value) && (
        <AddEntry
        data-testid="addEntry"
          key={addEntryKey}
          searchDate={searchDate}
          onDelayEntryDialogClose={() => onDelayEntryDialogClose()}
          onSaveFlightDelayDetail={handleSaveFlightDelayDetail}
        />
      )} 
    </div>
  );
}
